import React, { useState, useEffect } from 'react';

const MailerBags = ({ product, updateProduct }) => {
  const [selectedMaterial, setSelectedMaterial] = useState(product.fields.material || '');
  const [width, setWidth] = useState(product.fields.width || '');
  const [height, setHeight] = useState(product.fields.height || '');
  const [customMaterial, setCustomMaterial] = useState(product.fields.customMaterial || '');
  const [bubbleOption, setBubbleOption] = useState(product.fields.bubbleOption || '');

  useEffect(() => {
    updateProduct('width', width);
  }, [width, updateProduct]);

  useEffect(() => {
    updateProduct('height', height);
  }, [height, updateProduct]);

  // Plastic-based material options for mailer bags
  const materialOptions = [
    "PET / VMPET / PE",
    "PET / PE",
    "MATTE OPP / VMPET / PE",
    "PET / AL / PE",
    "PET / LDPE",
    "ALOX",
    "PE / PE",
    "MATTE OPP / PET / PE",
    "Other"
  ];

  // Material options mapping for mailer bags
  const materialToOptionsMap = {
    "PET / VMPET / PE": {
      microns: ["90", "100", "110", "120"],
      specialFeatures: ["Smell Proof", "Light Proof", "Microwaveable", "Moisture Resistant", "Air Proof", "Cold Temperature Proof", "Heat Proof"],
      printingFinishes: ["Gloss Lamination", "Matte Lamination", "Gloss Varnish", "Matte Varnish", "Soft Touch", "Hologram Lamination"],
      substrateType: ["Hologram", "Metallic", "Clear", "White", "Kraft"]
    },
    "PET / PE": {
      microns: ["90", "100", "110", "120"],
      specialFeatures: ["Smell Proof", "Light Proof", "Microwaveable", "Moisture Resistant", "Air Proof", "Cold Temperature Proof", "Heat Proof"],
      printingFinishes: ["Gloss Lamination", "Matte Lamination", "Gloss Varnish", "Matte Varnish", "Soft Touch", "Hologram Lamination"],
      substrateType: ["Hologram", "Metallic", "Clear", "White", "Kraft"]
    },
    "MATTE OPP / VMPET / PE": {
      microns: ["90", "100", "110", "120"],
      specialFeatures: ["Smell Proof", "Light Proof", "Microwaveable", "Moisture Resistant", "Air Proof", "Cold Temperature Proof", "Heat Proof"],
      printingFinishes: ["Gloss Lamination", "Matte Lamination", "Gloss Varnish", "Matte Varnish", "Soft Touch", "Hologram Lamination"],
      substrateType: ["Hologram", "Metallic", "Clear", "White", "Kraft"]
    },
    "PET / AL / PE": {
      microns: ["90", "100", "110", "120"],
      specialFeatures: ["Smell Proof", "Light Proof", "Microwaveable", "Moisture Resistant", "Air Proof", "Cold Temperature Proof", "Heat Proof"],
      printingFinishes: ["Gloss Lamination", "Matte Lamination", "Gloss Varnish", "Matte Varnish", "Soft Touch", "Hologram Lamination"],
      substrateType: ["Hologram", "Metallic", "Clear", "White", "Kraft"]
    },
    "PET / LDPE": {
      microns: ["90", "100", "110", "120"],
      specialFeatures: ["Smell Proof", "Light Proof", "Microwaveable", "Moisture Resistant", "Air Proof", "Cold Temperature Proof", "Heat Proof"],
      printingFinishes: ["Gloss Lamination", "Matte Lamination", "Gloss Varnish", "Matte Varnish", "Soft Touch", "Hologram Lamination"],
      substrateType: ["Hologram", "Metallic", "Clear", "White", "Kraft"]
    },
    "ALOX": {
      microns: ["90", "100", "110", "120"],
      specialFeatures: ["Thin Transparent Aluminum Oxide Coating", "Smell Proof", "Light Proof", "Microwaveable", "Moisture Resistant", "Air Proof", "Cold Temperature Proof", "Heat Proof"],
      printingFinishes: [],
      substrateType: []
    },
    "PE / PE": {
      microns: ["90", "100", "110", "120"],
      specialFeatures: ["Smell Proof", "Light Proof", "Microwaveable", "Moisture Resistant", "Air Proof", "Cold Temperature Proof", "Heat Proof"],
      printingFinishes: ["Gloss Lamination", "Matte Lamination", "Gloss Varnish", "Matte Varnish", "Soft Touch", "Hologram Lamination"],
      substrateType: []
    },
    "MATTE OPP / PET / PE": {
      microns: ["90", "100", "110", "120"],
      specialFeatures: ["Smell Proof", "Light Proof", "Microwaveable", "Moisture Resistant", "Air Proof", "Cold Temperature Proof", "Heat Proof"],
      printingFinishes: ["Gloss Lamination", "Matte Lamination", "Gloss Varnish", "Matte Varnish", "Soft Touch", "Hologram Lamination"],
      substrateType: ["Clear", "White"]
    },
    "48MIL CT PET": {
      microns: ["90", "100", "110", "120"],
      specialFeatures: ["Smell Proof", "Light Proof", "Microwaveable", "Moisture Resistant", "Air Proof", "Cold Temperature Proof", "Heat Proof"],
      printingFinishes: ["Gloss Lamination", "Matte Lamination", "Gloss Varnish", "Matte Varnish", "Soft Touch", "Hologram Lamination"],
      substrateType: ["Hologram", "Metallic", "Clear", "White", "Kraft"]
    },
    "48MIL METPET": {
      microns: ["90", "100", "110", "120"],
      specialFeatures: ["Smell Proof", "Light Proof", "Microwaveable", "Moisture Resistant", "Air Proof", "Cold Temperature Proof", "Heat Proof"],
      printingFinishes: ["Gloss Lamination", "Matte Lamination", "Gloss Varnish", "Matte Varnish", "Soft Touch", "Hologram Lamination"],
      substrateType: ["Hologram", "Metallic", "Clear", "White", "Kraft"]
    },
    "3.50MIL CLEAR PE": {
      microns: ["90", "100", "110", "120"],
      specialFeatures: ["Smell Proof", "Light Proof", "Microwaveable", "Moisture Resistant", "Air Proof", "Cold Temperature Proof", "Heat Proof"],
      printingFinishes: ["Gloss Lamination", "Matte Lamination", "Gloss Varnish", "Matte Varnish", "Soft Touch", "Hologram Lamination"],
      substrateType: ["Clear", "White"]
    }
  };

  // Handle material change
  const handleMaterialChange = (e) => {
    const material = e.target.value;
    setSelectedMaterial(material);
    
    if (material === 'Other') {
      updateProduct('material', '');
    } else {
      updateProduct('material', material);
      setCustomMaterial('');
    }
    
    // Reset dependent fields
    updateProduct('microns', '');
    updateProduct('layers', '');
    updateProduct('specialFeatures', []);
    updateProduct('printingFinishes', '');
    updateProduct('substrateType', '');
  };

  // Add handler for custom material input
  const handleCustomMaterialChange = (e) => {
    const value = e.target.value;
    setCustomMaterial(value);
    updateProduct('material', value);
    updateProduct('customMaterial', value);
  };

  // Handle bubble option change
  const handleBubbleOptionChange = (e) => {
    const value = e.target.value;
    setBubbleOption(value);
    updateProduct('bubbleOption', value);
  };

  // Render conditional fields based on selected material
  const renderConditionalFields = () => {
    if (!selectedMaterial) return null;
    
    const options = materialToOptionsMap[selectedMaterial] || {
      microns: [],
      specialFeatures: [],
      printingFinishes: [],
      substrateType: []
    };

    return (
      <>
        {/* Microns */}
        <div className="form-group">
          <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Thickness (Microns):</label>
          <input
            type="number"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg"
            value={product.fields.microns || '120'} 
            min={1}
            onBlur={(e) => {
              const newMicrons = e.target.value;
              if (!newMicrons || newMicrons <= 0) {
                alert("Error: Please set a valid microns value.");
                e.target.value = product.fields.microns || '120';
                return;
              }
              if (window.confirm("Are you sure you want to change the microns value?")) {
                updateProduct('microns', newMicrons);
              } else {
                e.target.value = product.fields.microns || '120';
              }
            }}
            onChange={(e) => {
              updateProduct('microns', e.target.value);
            }}
          />
          <div className="mt-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                className="mr-2"
                checked={product.fields.requestMicronRecommendation || false}
                onChange={(e) => updateProduct('requestMicronRecommendation', e.target.checked)}
              />
              <span className="text-sm">Request a recommendation from production</span>
            </label>
          </div>
        </div>

        {/* Printing Finishes */}
        {Array.isArray(options.printingFinishes) && options.printingFinishes.length > 0 && (
          <div className="form-group">
            <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Printing Finishes:</label>
            <select
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg"
              value={product.fields.printingFinishes || ''}
              onChange={(e) => updateProduct('printingFinishes', e.target.value)}
            >
              <option value="">Select Printing Finish</option>
              {options.printingFinishes.map((finish, index) => (
                <option key={index} value={finish}>{finish}</option>
              ))}
            </select>
          </div>
        )}

        {/* Substrate Type */}
        {Array.isArray(options.substrateType) && options.substrateType.length > 0 && (
          <div className="form-group">
            <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Substrate Type:</label>
            <select
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              value={product.fields.substrateType || ''}
              onChange={(e) => updateProduct('substrateType', e.target.value)}
            >
              <option value="">Select Substrate Type</option>
              {options.substrateType.map((substrate, index) => (
                <option key={index} value={substrate}>{substrate}</option>
              ))}
            </select>
          </div>
        )}

        {/* Special Features */}
        <div className="form-group">
          <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Special Features:</label>
          <div className="grid gap-2 grid-cols-2">
            {options.specialFeatures.map((feature, index) => (
              <label key={index} className="flex items-center">
                <input
                  type="checkbox"
                  className="mr-2"
                  checked={product.fields.specialFeatures?.includes(feature) || false}
                  onChange={(e) => {
                    let currentFeatures = product.fields.specialFeatures ? product.fields.specialFeatures.split(',') : [];
                    if (currentFeatures.includes(feature)) {
                      currentFeatures = currentFeatures.filter(f => f !== feature);
                    } else {
                      currentFeatures.push(feature);
                    }
                    updateProduct('specialFeatures', currentFeatures.join(','));
                  }}
                />
                {feature}
              </label>
            ))}
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="product-form">
      {/* Size (W x H) */}
      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Size (W x H in mm):</label>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Width (W)</label>
            <input
              type="number"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5"
              value={width}
              onChange={(e) => setWidth(e.target.value)}
              placeholder="Enter width"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Height (H)</label>
            <input
              type="number"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5"
              value={height}
              onChange={(e) => setHeight(e.target.value)}
              placeholder="Enter height"
            />
          </div>
        </div>
      </div>

      {/* Material */}
      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Primary Material:</label>
        <select
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5"
          value={selectedMaterial}
          onChange={handleMaterialChange}
        >
          <option value="">Select Primary Material</option>
          {materialOptions.map((material, index) => (
            <option key={index} value={material}>{material}</option>
          ))}
        </select>
        
        {selectedMaterial === 'Other' && (
          <div className="mt-2">
            <input
              type="text"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5"
              value={customMaterial}
              onChange={handleCustomMaterialChange}
              placeholder="Enter custom material"
            />
          </div>
        )}
      </div>

      {/* Secondary Material */}
      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Secondary Material:</label>
        <input
          type="text"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5"
          value={product.fields.secondaryMaterial || ''}
          onChange={(e) => updateProduct('secondaryMaterial', e.target.value)}
          placeholder="Enter secondary material"
        />
      </div>

      {/* Bubble Option */}
      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">Bubble Option:</label>
        <div className="flex space-x-6">
          <label className="flex items-center">
            <input
              type="radio"
              name="bubbleOption"
              value="With Bubble"
              checked={bubbleOption === 'With Bubble'}
              onChange={handleBubbleOptionChange}
              className="mr-2"
            />
            <span className="text-sm">With Bubble</span>
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="bubbleOption"
              value="Without Bubble"
              checked={bubbleOption === 'Without Bubble'}
              onChange={handleBubbleOptionChange}
              className="mr-2"
            />
            <span className="text-sm">Without Bubble</span>
          </label>
        </div>
      </div>

      {/* Conditional Fields Based on Material */}
      {renderConditionalFields()}

      {/* Product Type */}
      <div className="form-group">
        <label className="block tracking-wide text-sm font-bold leading-6 text-gray-900">What type of products will be used in the mailer bags?</label>
        <input
          type="text"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          value={product.fields.productType || ''}
          onChange={(e) => updateProduct('productType', e.target.value)}
          placeholder="Enter product type"
        />
      </div>
    </div>
  );
};

export default MailerBags;